var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ojo3nD9oh_BLoC.P0_8HDQOFGPEJA._2yVKrPWt0JqQw8{text-align:center}.ojo3nD9oh_BLoC.P0_8HDQOFGPEJA>._1aHMqzuS7eF9Eq{margin:0 auto}.ojo3nD9oh_BLoC._2yVKrPWt0JqQw8>._1aHMqzuS7eF9Eq{display:inline-block;vertical-align:middle}._1aHMqzuS7eF9Eq{background-image:url(" + escape(require("resources/images/spinner.svg")) + ");background-size:30px 30px;display:block;height:30px;width:30px}._1aHMqzuS7eF9Eq._2o84EP8FdPc1vl{background-size:18px 18px;height:18px;width:18px}._1aHMqzuS7eF9Eq._1SCIbLFuTIufZe{margin-right:3px}", ""]);

// exports
exports.locals = {
	"wrapper": "ojo3nD9oh_BLoC",
	"centered": "P0_8HDQOFGPEJA",
	"inline": "_2yVKrPWt0JqQw8",
	"spinner": "_1aHMqzuS7eF9Eq",
	"small": "_2o84EP8FdPc1vl",
	"modLeft": "_1SCIbLFuTIufZe"
};